import { render, staticRenderFns } from "./vat-group-details.vue?vue&type=template&id=297d70da&lang=pug"
import script from "./vat-group-details.vue?vue&type=script&lang=ts"
export * from "./vat-group-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports